import { useState } from 'react'
import type { AppCore } from '@core/bootstrap'
import { useAuthToken } from './useAuthToken'
import { PriceImportSection } from './PriceImportSection'
import { CloudCatalogPublishSection } from './CloudCatalogPublishSection'
import { cx, hint } from '@ui/classes'
import { seg, segActive, segBar, segDisabled, segIdle } from '@ui/admin'

/**
 * Импорт каталога: одна карточка с вкладками «На эту кассу» (локально) и
 * «Все кассы (облако)». Сами блоки импорта не переписаны — только обёрнуты.
 */
export function CatalogImportSection({
  core,
  onImported
}: {
  core: AppCore
  onImported?: () => void
}) {
  const token = useAuthToken()
  const [target, setTarget] = useState<'local' | 'cloud'>('local')

  return (
    <div>
      <div className={segBar} role="tablist" aria-label="Куда импортировать каталог">
        <button
          type="button"
          role="tab"
          aria-selected={target === 'local'}
          className={cx(seg, target === 'local' ? segActive : segIdle)}
          onClick={() => setTarget('local')}
        >
          На эту кассу
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={target === 'cloud'}
          disabled={!token}
          className={cx(seg, target === 'cloud' ? segActive : segIdle, !token && segDisabled)}
          onClick={() => setTarget('cloud')}
          title={!token ? 'Подключите облако в «Интеграциях»' : undefined}
        >
          Все кассы (облако)
        </button>
      </div>

      <p className={hint}>
        На эту кассу — сразу, без облака. Все кассы — публикация после импорта.
      </p>

      {target === 'local' ? (
        <PriceImportSection core={core} onImported={onImported} />
      ) : (
        <CloudCatalogPublishSection />
      )}
    </div>
  )
}